<template>
  <q-dialog
    v-model="shown"
    :maximized="$q.screen.lt.md"
  >
    <q-card style="min-width: 50%;">
      <q-card-section class="row items-center q-mx-xs">
        <div
          class="text-h6"
        >
          Notes
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section class="row justify-center">
        <q-input
          v-model="model.notes"
          class="col"
          type="textarea"
        />
      </q-card-section>
      <q-card-actions class="row justify-end q-ma-sm">
        <q-btn
          v-close-popup
          label="Done"
          color="primary"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>

export default {
  name: 'NotesDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    model: {
      type: Object,
      required: true
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      shown: false
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  methods: {
    show (id) {
      this.id = id
      this.shown = true
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
